export const TARGETS = {
  IMPORT_EVENTS: 'importEvents',
  GET_EVENTS: 'getEvents',
  UPLOAD_EVENT: 'uploadEvent',
  DELETE_EVENT: 'deleteEvent',
  EDIT_EVENT: 'editEvent'
};
